import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import {
  buildingCommonFields,
  buildingRevisionFields,
} from './common/buildingCommonFields';
import { msg } from '@lingui/core/macro';
import {
  fuelCombustionReasonField,
  fuelConsumptionQuantityField,
  fuelKindField,
  rawFuelUnitField,
} from './common/fuelFields';
import { utilityCostFields } from './common/utilityCostFields';

export const buildingStationaryCombustionMetadata = {
  displayName: msg({
    message: 'Facilities stationary combustion',
    context: 'Activity data schema name for facilities stationary combustion',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...buildingCommonFields,
    ...buildingRevisionFields,
    ...utilityCostFields,
    fuel_combustion_reason: fuelCombustionReasonField,
    fuel_kind: fuelKindField,
    quantity: fuelConsumptionQuantityField,
    unit: rawFuelUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
